(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/views/username/login.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/views/username/login.js'); "use strict";

(function (Backbone, _, svs) {
  'use strict';

  svs.player_login.behaviors.UsernameLogin = Marionette.Behavior.extend({
    ui: {
      loginFieldset: '.js-fieldset-username-login',
      errorMessage: '.error-message',
      usernameInput: '#username',
      passwordInput: '#password',
      forgottenLoginLink: '.js-forgotten-login',
      usernameTab: 'li[data-tab*="usernameTab"]'
    },
    events: {
      'submit .js-username-login-form': 'onSubmit',
      'click @ui.forgottenLoginLink': 'onForgottenLoginClick',
      'click @ui.usernameTab': 'onUsernameTabClick'
    },
    onAttach: function onAttach() {
      var serversideLoginError = this.view.getOption('usernameLoginError');

      if (serversideLoginError) {
        this.handleErrorCode(serversideLoginError.code, serversideLoginError.message);
      }

      if (this.ui.usernameInput.val().trim().length === 0) {
        this.ui.usernameInput.val(svs.components.Storage.browser.get('username', 'svs.components.login'));
      }
    },
    onUsernameTabClick: function onUsernameTabClick() {
      var self = this;

      if (this.ui.usernameInput.val().length > 0) {
        setTimeout(function () {
          self.ui.passwordInput.focus();
        }, 0);
      }
    },
    onForgottenLoginClick: function onForgottenLoginClick(e) {
      e.preventDefault();
      var content = svs.core.detect.formfactor.mobile() ? '<div id="order-username-or-password-container"></div>' : '<div id="order-username-or-password-container" class="padding-xs-2 bg-white"></div>';
      svs.components.overlay.show(content, true, {
        className: 'order-username-or-password-overlay'
      });
      svs.core.module.load('/glomt-inloggningsuppgifter');
    },
    onSubmit: function onSubmit(e) {
      var userName = this.ui.usernameInput.val().trim(),
          userPassword = this.ui.passwordInput.val().trim();
      e.preventDefault();

      if (userName.length && userPassword.length) {
        this.view.model.set({
          username: userName,
          password: userPassword
        });
        this.postToBackend();
      }
    },
    postToBackend: function postToBackend() {
      var deviceType;

      switch (svs.core.data.capabilities.channel) {
        case 'ios-hybrid-mobile':
        case 'android-hybrid-mobile':
          deviceType = 5;
          break;

        case 'ios-hybrid-tablet':
        case 'android-hybrid-tablet':
          deviceType = 6;
          break;

        case 'web-mobile':
          deviceType = 1;
          break;

        case 'web-tablet':
          deviceType = 2;
          break;

        case 'web-desktop':
          deviceType = 3;
          break;

        default:
          deviceType = 1;
      }

      if (this.view.model.get('password')) {
        svs.events.publish('/loader/show');
        svs.core.jupiter.call({
          method: 'POST',
          path: '/player/sessions',
          data: {
            userName: this.view.model.get('username'),
            password: this.view.model.get('password'),
            source: deviceType
          },
          useExtErrFunc: false,
          context: this
        }, this.onPostSuccess, this.onPostError);
      }
    },
    onPostSuccess: function onPostSuccess(result) {
      var self = this,
          logger = svs.core.log.getLogger('modules:player-login');
      var dateNow = new Date(); 

      var afterLastLoginTimeSetCallback;
      var isBlocked = result && result.session && result.session.isBlocked,
          userNotifs = result && result.userNotifications;
      svs.events.publish('/loader/hide'); 

      svs.components.analytics.trackEvent({
        category: 'Users',
        action: 'Login Success'
      });
      svs.components.Storage.browser.set('username', 'svs.components.login', this.view.model.get('username'), svs.components.Storage.constants.EXPIRES_1YEAR);

      if (isBlocked || userNotifs) {
        if (isBlocked && userNotifs && userNotifs.REDIRECT) {
          this.view.model.set('action', 'show_national_suspension_message_then_password_redirect');
        } else if (isBlocked) {
          this.view.model.set('action', 'show_national_suspension_message');
        } else if (userNotifs && userNotifs.REDIRECT) {
          this.view.model.set('action', 'password_redirect');
        } else if (userNotifs && userNotifs.HAS_SUSPENSION) {
          this.view.model.set('action', 'show_suspension');
        } else if (userNotifs && userNotifs.SHOW_SUSP_REMINDER) {
          this.view.model.set('action', 'show_suspension_reminder');
        }

        afterLastLoginTimeSetCallback = function afterLastLoginTimeSetCallback() {
          svs.player_login.router.navigate('spelpaus', true);
        };
      } else {
        afterLastLoginTimeSetCallback = function afterLastLoginTimeSetCallback() {
          svs.utils.url.navigate(svs.utils.url.makeInternal(self.view.model.get('returnUrl'), svs.utils.urlMapping.get('startPage')));
        };
      }

      var lastLoginTime = result && result.lastLoginTime || ''; 

      if (lastLoginTime === '') {
        logger.info('No lastLoginTime in session response');
      } else if (svs.player_login.utils.date.parseLastLoginTime(lastLoginTime, true) === svs.player_login.utils.date.format(dateNow, true)) {
        logger.info("lastLoginTime from backend (".concat(lastLoginTime, ") seems to be currentLoginTime. It is the same date, same hour, same minute and same second"));
      } else {
        logger.info("lastLoginTime from backend (".concat(lastLoginTime, ")"));
      }

      if (result.userNotifications && result.userNotifications.PART_OF_CAMPAIGN) {
        svs.core.userSession.set('partofcampaign', true, function () {
          svs.core.userSession.set('lastLoginTime', svs.player_login.utils.date.parseLastLoginTime(lastLoginTime, false), function () {
            afterLastLoginTimeSetCallback();
          });
        }); 
      } else {
        svs.core.userSession.set('lastLoginTime', svs.player_login.utils.date.parseLastLoginTime(lastLoginTime, false), function () {
          afterLastLoginTimeSetCallback();
        });
      }
    },
    onPostError: function onPostError(result) {
      var errorCode = -1;
      svs.events.publish('/loader/hide');

      if (result.responseText) {
        errorCode = JSON.parse(result.responseText).error.code;
      }

      this.handleErrorCode(errorCode, result.responseText);
    },
    handleErrorCode: function handleErrorCode(errorCode, responseText) {
      var errorMessagePrefix = 'Login failed.';
      var errorMessageReason = 'Unknown.';
      var logError = false;
      var dialogObject = {
        title: 'Tekniskt fel',
        message: 'Var vänlig försök igen senare.',
        button: 'Stäng',
        buttonType: svs.components.MessageBox.ButtonType.OK
      };

      switch (errorCode) {
        case 1:
          errorMessageReason = 'Default error.';
          this.showErrorDialog(dialogObject);
          logError = true;
          break;

        case 2: 

        case 13:
          errorMessageReason = 'Wrong password or username.';
          this.showErrorMessage('Fel lösenord eller användarnamn');
          break;

        case 3:
          errorMessageReason = 'Invalid session.';
          this.showErrorDialog(dialogObject);
          logError = true;
          break;

        case 4:
          errorMessageReason = 'Invalid session id.';
          this.showErrorDialog(dialogObject);
          logError = true;
          break;

        case 5:
          errorMessageReason = 'Account locked. Too many wrong password tries.';
          this.showErrorMessage('Ditt konto har blivit låst');
          dialogObject.title = 'Kontot är låst';
          dialogObject.message = 'Ditt konto är låst. Vill du låsa upp så kontakta oss på kundservice!';
          dialogObject.button = 'Ok';
          dialogObject.buttonType = svs.components.MessageBox.ButtonType.ABORT;
          this.showErrorDialog(dialogObject);
          break;

        case 6:
          errorMessageReason = 'Account locked by player or customer service.';
          this.showErrorMessage('Spärrat konto');
          dialogObject.title = 'Inloggning misslyckades';
          dialogObject.message = 'Ditt spelkonto är spärrat. Vid frågor, ring Svenska Spels Kundservice, 0770 - 11 11 11';
          this.showErrorDialog(dialogObject);
          break;

        case 22:
          errorMessageReason = 'Timeout from NAR.';
          dialogObject.title = 'Inloggning misslyckades';
          dialogObject.message = 'Ups! Vår slagning mot Spelpaus.se för att se om du är spelpausad eller ej gav inget svar. Vänligen försök igen. Vid frågor, ring Svenska Spels Kundservice, 0770 - 11 11 11';
          this.showErrorDialog(dialogObject);
          break;

        default:
          errorMessageReason = "Unknown. ".concat(responseText ? " Response text: ".concat(responseText) : '');
          this.showErrorDialog(dialogObject);
          logError = true;
      }

      var errorMessageFull = "".concat(errorMessagePrefix, " Error code: ").concat(errorCode, " Reason: ").concat(errorMessageReason); 

      svs.components.analytics.trackEvent({
        category: 'Users',
        action: 'Login Failure',
        opt_label: 'username',
        opt_value: errorCode
      });

      if (logError) {
        svs.player_login.logger.error(errorMessageFull);
      }
    },
    showErrorDialog: function showErrorDialog(dialogObject) {
      var dialog = new svs.components.dialog.Confirm({
        type: svs.components.dialog.type.ERROR,
        title: dialogObject.title,
        message: [{
          type: svs.components.dialog.message.TEXT,
          text: dialogObject.message
        }],
        actions: [{
          title: dialogObject.button
        }]
      });
      svs.components.dialog.api.add(dialog);
    },
    showErrorMessage: function showErrorMessage(error) {
      this.ui && this.ui.loginFieldset && this.ui.loginFieldset.addClass && this.ui.loginFieldset.addClass('error');
      this.ui && this.ui.errorMessage && this.ui.errorMessage.html && this.ui.errorMessage.html(error);
    }
  });
})(Backbone, _, svs);
 })(window);